import ErrorHandler from './ErrorHandler';
import { ErrorHandlerProps } from './types';

export type { ErrorHandlerProps };
export default ErrorHandler;
